module.exports = __webpack_public_path__ + "img/camiseta-preta-costas.7570542c.jpg";